var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "share-btn-box" }, [
    _c(
      "div",
      {
        staticClass: "share-btn",
        class: { disabled: _vm.complete !== true },
        on: { click: _vm.shareJob },
      },
      [
        _c("i", { staticClass: "far fa-share-alt" }),
        _vm._v("\n    " + _vm._s(_vm._f("trans")("Share")) + "\n  "),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }